export var STAGE_ADMIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6Mjg5OTAyMjU1NywiaWF0IjoxNjY0NDU0NjY3fQ.lDypk5URPpLbr4tgniyEPr7SfCBYTmuQ-xxXAv8OrgA';
export var PROD_ADMIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6Mjg5OTAyMjUxMSwiaWF0IjoxNjY0NDU0NjIxfQ.z8q29NN95P6l17MfJH6gDV9lxUx03-Gl37UyMYRwSTs';
export var STAGE_CENTRIFUGE_DOMAIN = 'sup-stage.samoletgroup.ru';
export var PROD_CENTRIFUGE_DOMAIN = 'sup.samoletgroup.ru';
export var SUP_API = '/api/v1/notifications/';
export var SUP_PROD_DOMAIN = 'sup.samoletgroup.ru';
export var SUP_STAGE_DOMAIN = 'sup-stage.samoletgroup.ru';
export var SUP_URL = 'https://' + SUP_PROD_DOMAIN;
export var CREATE_REQUEST_ENDPOINT = '/api/sup/v1/issues/';
export var SUGGEST_PROJECTS_ENDPOINT = '/api/v1/suggest/projects/';
export var SUGGEST_PROBLEMS_ENDPOINT = '/api/v1/suggest/problems/';
//# sourceMappingURL=common.js.map